import { Checkbox, DataHeader, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffManagementAdvancedSearch extends Layout {
    checkboxChargeRegardlessFlag: Checkbox;
    checkboxDeficitRating: Checkbox;
    checkboxReversibleFlag: Checkbox;
    dataHeaderTariffManagement: DataHeader;
    labelR: Label;
    labelRateCalculation: Label;
    labelTariffDetails: Label;
    labelTariffLineItem: Label;
    panelTariffLineItem: Panel;
    panelTariffManagement: Panel;
    sourceTariffLineItem: DataSource;
    sourceTarrif: DataSource;
    textboxAveragePalletWeight: Textbox;
    textboxCalcFactor2: Textbox;
    textboxCalcFactor: Textbox;
    textboxCalcUomCode: Textbox;
    textboxCarrierScac: Textbox;
    textboxCompareOptionCode: Textbox;
    textboxConsRegName: Textbox;
    textboxConveyanceTypeCode: Textbox;
    textboxCubicUnits: Textbox;
    textboxCurrency: Textbox;
    textboxDefaultCurrency: Textbox;
    textboxDescription: Textbox;
    textboxDimWeightMultiplier: Textbox;
    textboxEffectiveTimestamp: Textbox;
    textboxExpireTimestamp: Textbox;
    textboxFallbackTariffId: Textbox;
    textboxFreightValue: Textbox;
    textboxGlaUid: Textbox;
    textboxHandlingUnits: Textbox;
    textboxLinearUnits: Textbox;
    textboxMaximumCharge: Textbox;
    textboxMiles: Textbox;
    textboxMinimumCharge: Textbox;
    textboxMinimumWeightPerPallet: Textbox;
    textboxNmfc: Textbox;
    textboxPieces: Textbox;
    textboxPriority: Textbox;
    textboxProductSku: Textbox;
    textboxQualFactor1: Textbox;
    textboxQualFactor2: Textbox;
    textboxRate: Textbox;
    textboxRateNote: Textbox;
    textboxServiceTypeCode: Textbox;
    textboxShipRegName: Textbox;
    textboxSpots: Textbox;
    textboxTLIEffectiveTimestamp: Textbox;
    textboxTLIExpireTimestamp: Textbox;
    textboxTariffId: Textbox;
    textboxTariffName: Textbox;
    textboxTariffTypeCode: Textbox;
    textboxTliUid: Textbox;
    textboxWeight: Textbox;
}
